export const RECV_TYPE_NONE = 0;
export const RECV_TYPE_STAFF = 1;
export const RECV_TYPE_DRIVER = 2;
export const RECV_TYPE_STAFF_DRIVER_NONE = 3;
export const RECV_TYPE_STAFF_DRIVER = 4;
export const RECV_TYPE_DRIVER_STAFF = 5;

export const COLLECT_TYPE_NONE = 0;
export const COLLECT_TYPE_NORMAL = 1;

export const PAY_TYPE_NONE = 0;
export const PAY_TYPE_STAFF = 1;
export const PAY_TYPE_DRIVER = 2;
export const PAY_TYPE_STAFF_DRIVER_NONE = 3;
export const PAY_TYPE_STAFF_DRIVER = 4;
export const PAY_TYPE_DRIVER_STAFF = 5;

export const PAY_TIMING_NONE = 0;
export const PAY_TIMING_HIMEFIX = 1;
export const PAY_TIMING_RESV = 2;

export const RECV_TIMING_RESV = 1;
export const RECV_TIMING_HIMEFIX = 2; 
export const RECV_TIMING_HIMEFIX_RESV = 3; 
export const RECV_TIMING_HIMEFIX_RESV_PAYVIEW = 4; 
export const RECV_TIMING_HIMEFIX_RESV_PAYVIEW2 = 5;

export const RECV_METHOD_NONE = 0;
export const RECV_METHOD_HAND = 1;
export const RECV_METHOD_HAND_PAYMENT = 2;
export const RECV_METHOD_PAYMENT_HAND = 3;

export const BILL_TYPE_NONE = 0;
export const BILL_TYPE_BOARD = 1;
export const BILL_TYPE_CARD = 2;

export const OPTION_SP = 1000;
export const OPTION_SHOP = 4000;
export const OPTION_VP = 2000;
export const OPTION_VP_MAIN = 2000;
export const OPTION_HP_WORK = 1000;
export const OPTION_CP = 1000;
export const OPTION_NET = 4000;
export const OPTION_POINT = 2000;
export const OPTION_POINT2 = 1000;
export const OPTION_BUSINESS_PHONE = 5000;
export const OPTION_CALL_OUT = 3000;
